const tables = {
  matomoVisits: {
    schema: 'matomo',
    table: 'matomo_visits',
    joinColumns: {
      matomoActions: 'matomoVisits.idvisit',
      questionResponses: 'toString(matomoVisits.idvisit)',
    },
    dateField: 'visitFirstActionTime',
  },
  matomoActions: {
    schema: 'matomo',
    table: 'matomo_actions',
    joinColumns: {
      matomoVisits: 'matomoActions.idvisit',
      questionResponses: 'toString(matomoActions.idvisit)',
    },
    dateField: 'actionTime',
  },
  questionResponses: {
    schema: 'survey',
    table: 'question_responses',
    joinColumns: {
      matomoVisits: 'questionResponses.matomoVisitId',
      matomoActions: 'questionResponses.matomoVisitId',
    },
    dateField: 'surveyResponseTime',
  },
};

const fields = {
  // matomoVisits
  visitFirstActionTime: {
    column: 'visit_first_action_time',
    type: 'date',
    segment: false,
    table: 'matomoVisits',
  },
  visitLastActionTime: {
    column: 'visit_last_action_time',
    type: 'date',
    segment: false,
    table: 'matomoVisits',
  },
  visitSiteId: {
    column: 'idsite',
    segment: false,
    table: 'matomoVisits',
  },
  visitId: {
    column: 'idvisit',
    type: 'number',
    table: 'matomoVisits',
  },
  visitorId: {
    column: 'idvisitor',
    table: 'matomoVisits',
  },
  visitEvents: {
    column: 'visit_total_events',
    type: 'number',
    table: 'matomoVisits',
  },
  visitInteractions: {
    column: 'visit_total_interactions',
    type: 'number',
    table: 'matomoVisits',
  },
  visitSearches: {
    column: 'visit_total_searches',
    type: 'number',
    table: 'matomoVisits',
  },
  visitTotalTime: {
    column: 'visit_total_time',
    type: 'seconds',
    table: 'matomoVisits',
  },
  visitTotalActions: {
    column: 'visit_total_actions',
    type: 'number',
    table: 'matomoVisits',
  },
  visitBounced: {
    columnSql: 'if(visit_total_actions <= 1, idvisit, null)',
    type: 'number',
    table: 'matomoVisits',
  },
  visitEntryUrl: {
    column: 'visit_entry_idaction_url_name',
    table: 'matomoVisits',
  },
  visitEntryTitle: {
    column: 'visit_entry_idaction_name_name',
    table: 'matomoVisits',
  },
  visitExitUrl: {
    column: 'visit_exit_idaction_url_name',
    table: 'matomoVisits',
  },
  visitExitTitle: {
    column: 'visit_exit_idaction_name_name',
    table: 'matomoVisits',
  },
  visitExit: {
    columnSql: 'if(visit_exit_idaction_url_name = idaction_url_name, idvisit, null)',
    type: 'number',
    table: 'matomoVisits',
  },
  visitGoalConverted: {
    column: 'visit_goal_converted',
    type: 'boolean',
    table: 'matomoVisits',
  },
  visitorReturning: {
    column: 'visitor_returning',
    type: 'boolean',
    table: 'matomoVisits',
  },
  visitorVisitCount: {
    column: 'visitor_count_visits',
    type: 'number',
    table: 'matomoVisits',
  },
  visitorSecondsSinceFirstVisit: {
    column: 'visitor_seconds_since_first',
    type: 'number',
    table: 'matomoVisits',
  },
  visitorSecondsSinceLastVisit: {
    column: 'visitor_seconds_since_last',
    type: 'number',
    table: 'matomoVisits',
  },
  visitorCountry: {
    column: 'location_country',
    type: 'country',
    table: 'matomoVisits',
  },
  visitorCity: {
    column: 'location_city',
    table: 'matomoVisits',
  },
  visitorLongitude: {
    column: 'location_longitude',
    table: 'matomoVisits',
  },
  visitorLatitude: {
    column: 'location_latitude',
    table: 'matomoVisits',
  },
  visitorLocalTime: {
    column: 'visitor_localtime',
    table: 'matomoVisits',
  },
  visitorLocalHour: {
    columnSql: 'toHour(toDateTime(concat(\'1970-01-01 \', visitor_localtime)))',
    type: 'number',
    table: 'matomoVisits',
  },
  visitWebsiteHour: {
    columnSql: 'toHour(toTimeZone(visit_first_action_time, \'{timezone}\'))',
    type: 'number',
    table: 'matomoVisits',
  },
  deviceType: {
    column: 'config_device_type',
    type: 'deviceType',
    table: 'matomoVisits',
  },
  deviceBrand: {
    column: 'config_device_brand',
    type: 'deviceBrand',
    table: 'matomoVisits',
  },
  deviceModel: {
    column: 'config_device_model',
    table: 'matomoVisits',
  },
  deviceOs: {
    column: 'config_os',
    type: 'operatingSystem',
    table: 'matomoVisits',
  },
  deviceOsVersion: {
    column: 'config_os_version',
    type: 'number',
    table: 'matomoVisits',
  },
  deviceOsAndVersion: {
    columnSql: 'concat(config_os, \' \', config_os_version)',
    table: 'matomoVisits',
  },
  deviceResolution: {
    column: 'config_resolution',
    table: 'matomoVisits',
  },
  browserLanguage: {
    column: 'location_browser_lang',
    type: 'language',
    table: 'matomoVisits',
  },
  browserName: {
    column: 'config_browser_name',
    type: 'browser',
    table: 'matomoVisits',
  },
  browserVersion: {
    column: 'config_browser_version',
    type: 'number',
    table: 'matomoVisits',
  },
  browserNameAndVersion: {
    columnSql: 'concat(config_browser_name, \' \', config_browser_version)',
    table: 'matomoVisits',
  },
  browserCookies: {
    column: 'config_cookie',
    type: 'boolean',
    table: 'matomoVisits',
  },
  browserEngine: {
    column: 'config_browser_engine',
    table: 'matomoVisits',
  },
  referrerType: {
    column: 'referer_type',
    type: 'referrerType',
    table: 'matomoVisits',
  },
  referrerKeyword: {
    column: 'referer_keyword',
    table: 'matomoVisits',
  },
  referrerUrl: {
    column: 'referer_url',
    table: 'matomoVisits',
  },
  referrerName: {
    column: 'referer_name',
    table: 'matomoVisits',
  },
  campaignContent: {
    column: 'campaign_content',
    table: 'matomoVisits',
  },
  campaignGroup: {
    column: 'campaign_group',
    table: 'matomoVisits',
  },
  campaignKeyword: {
    column: 'campaign_keyword',
    table: 'matomoVisits',
  },
  campaignMedium: {
    column: 'campaign_medium',
    table: 'matomoVisits',
  },
  campaignName: {
    column: 'campaign_name',
    table: 'matomoVisits',
  },
  campaignSource: {
    column: 'campaign_source',
    table: 'matomoVisits',
  },
  campaignId: {
    column: 'campaign_id',
    table: 'matomoVisits',
  },
  campaignPlacement: {
    column: 'campaign_placement',
    table: 'matomoVisits',
  },

  // matomoActions
  actionId: {
    column: 'idlink_va',
    type: 'number',
    table: 'matomoActions',
  },
  actionVisitId: {
    column: 'idvisit',
    type: 'number',
    table: 'matomoActions',
  },
  actionTime: {
    column: 'server_time',
    type: 'date',
    segment: false,
    table: 'matomoActions',
  },
  actionSiteId: {
    column: 'idsite',
    segment: false,
    table: 'matomoActions',
  },
  actionUrl: {
    column: 'idaction_url_name',
    table: 'matomoActions',
  },
  actionUrlType: {
    column: 'idaction_url_type',
    type: 'number',
    table: 'matomoActions',
  },
  actionPageview: {
    columnSql: 'if(idaction_url_type = 1, idlink_va, null)',
    type: 'number',
    table: 'matomoActions',
  },
  actionUniquePageview: {
    columnSql: 'if(idaction_url_type = 1, concat(idvisit, idaction_url_name), null)',
    type: 'number',
    table: 'matomoActions',
  },
  actionOutlink: {
    columnSql: 'if(idaction_url_type = 2, idlink_va, null)',
    type: 'number',
    table: 'matomoActions',
  },
  actionUniqueOutlink: {
    columnSql: 'if(idaction_url_type = 2, concat(idvisit, idaction_url_name), null)',
    type: 'number',
    table: 'matomoActions',
  },
  actionDownload: {
    columnSql: 'if(idaction_url_type = 3, idlink_va, null)',
    type: 'number',
    table: 'matomoActions',
  },
  actionUniqueDownload: {
    columnSql: 'if(idaction_url_type = 3, concat(idvisit, idaction_url_name), null)',
    type: 'number',
    table: 'matomoActions',
  },
  actionSearch: {
    columnSql: 'if(idaction_name_type = 8, idlink_va, null)',
    type: 'number',
    table: 'matomoActions',
  },
  actionUniqueSearch: {
    columnSql: 'if(idaction_name_type = 8, concat(idvisit, idaction_name_name), null)',
    type: 'number',
    table: 'matomoActions',
  },
  actionTitle: {
    column: 'idaction_name_name',
    table: 'matomoActions',
  },
  actionTitleType: {
    column: 'idaction_name_type',
    type: 'number',
    table: 'matomoActions',
  },
  actionRefUrl: {
    column: 'idaction_url_ref_name',
    table: 'matomoActions',
  },
  actionRefUrlType: {
    column: 'idaction_url_ref_type',
    type: 'number',
    table: 'matomoActions',
  },
  actionRefTitle: {
    column: 'idaction_name_ref_name',
    table: 'matomoActions',
  },
  actionRefTitleType: {
    column: 'idaction_name_ref_type',
    type: 'number',
    table: 'matomoActions',
  },
  actionPageviewPosition: {
    column: 'pageview_position',
    type: 'number',
    table: 'matomoActions',
  },
  actionEntry: {
    columnSql: 'if(pageview_position <= 1, idvisit, null)',
    type: 'number',
    table: 'matomoActions',
  },
  eventCategory: {
    column: 'idaction_event_category_name',
    table: 'matomoActions',
  },
  eventCategoryType: {
    column: 'idaction_event_category_type',
    type: 'number',
    table: 'matomoActions',
  },
  eventAction: {
    column: 'idaction_event_action_name',
    table: 'matomoActions',
  },
  eventActionType: {
    column: 'idaction_event_action_type',
    type: 'number',
    table: 'matomoActions',
  },
  timeSpent: {
    column: 'time_spent',
    type: 'seconds',
    table: 'matomoActions',
  },
  timeSpentRefAction: {
    column: 'time_spent_ref_action',
    type: 'seconds',
    table: 'matomoActions',
  },
  timeDomCompletion: {
    column: 'time_dom_completion',
    type: 'seconds',
    table: 'matomoActions',
  },
  timeDomProcessing: {
    column: 'time_dom_processing',
    type: 'seconds',
    table: 'matomoActions',
  },
  timeNetwork: {
    column: 'time_network',
    type: 'seconds',
    table: 'matomoActions',
  },
  timeOnLoad: {
    column: 'time_on_load',
    type: 'seconds',
    table: 'matomoActions',
  },
  timeServer: {
    column: 'time_server',
    type: 'seconds',
    table: 'matomoActions',
  },
  timeTransfer: {
    column: 'time_transfer',
    type: 'seconds',
    table: 'matomoActions',
  },
  timeTotalPageLoad: {
    columnSql: 'time_network + time_server + time_transfer + time_dom_processing + time_dom_completion + time_on_load',
    type: 'milliseconds',
    table: 'matomoActions',
  },
  searchCategory: {
    column: 'search_cat',
    table: 'matomoActions',
  },
  searchResults: {
    column: 'search_count',
    type: 'number',
    table: 'matomoActions',
  },

  // questionResponses
  surveyResponseId: {
    column: 'surveyResponseId',
    type: 'number',
    table: 'questionResponses',
  },
  surveyResponseTime: {
    column: 'respondedAt',
    type: 'date',
    table: 'questionResponses',
  },
  surveyResponseCustomerId: {
    column: 'customerId',
    segment: false,
    table: 'questionResponses',
  },
  surveyResponseDataSourceId: {
    column: 'dataSourceId',
    segment: false,
    table: 'questionResponses',
  },
  surveyResponseWebsiteId: {
    column: 'websiteId',
    segment: false,
    table: 'questionResponses',
  },
  surveyResponseSurveyId: {
    column: 'surveyId',
    segment: false,
    type: 'survey',
    table: 'questionResponses',
  },
  surveyResponseSurveyGroupId: {
    column: 'surveyGroupId',
    segment: true,
    type: 'surveyGroup',
    table: 'questionResponses',
  },
  surveyResponseDistributionId: {
    column: 'distributionId',
    segment: false,
    table: 'questionResponses',
  },
  surveyRespondentDeviceType: {
    column: 'device',
    type: 'deviceType',
    table: 'questionResponses',
  },
  surveyRespondentCountry: {
    column: 'countryCode',
    type: 'country',
    table: 'questionResponses',
  },
  surveyRespondentBrowserLanguage: {
    column: 'language',
    type: 'language',
    table: 'questionResponses',
  },
  surveyResponsePageUrl: {
    column: 'webpageUrl',
    table: 'questionResponses',
  },
  surveyResponsePageTitle: {
    column: 'webpageTitle',
    table: 'questionResponses',
  },
  surveyResponseClientPanel: {
    column: 'clientPanel',
    type: 'boolean',
    table: 'questionResponses',
  },
  questionResponseId: {
    column: 'id',
    type: 'number',
    table: 'questionResponses',
  },
  questionResponseQuestionId: {
    column: 'questionId',
    type: 'surveyQuestion',
    table: 'questionResponses',
  },
  questionResponseQuestionType: {
    column: 'type',
    type: 'questionType',
    table: 'questionResponses',
  },
  questionResponseOptionId: {
    column: 'options',
    type: 'surveyOption',
    table: 'questionResponses',
  },
  questionResponseText: {
    column: 'text',
    table: 'questionResponses',
  },
  matomoVisitId: {
    column: 'idvisit',
    table: 'questionResponses',
  },
};

const aggregations = [{
  label: 'Unique count',
  value: 'uniqExact',
  sql: 'toUInt32(uniqExact({field}))',
}, {
  label: 'Count',
  value: 'count',
  sql: 'toUInt32(count({field}))',
}, {
  label: 'Sum',
  value: 'sum',
  sql: 'toUInt32(sum({field}))',
}, {
  label: 'Average',
  value: 'avg',
  sql: 'avgIf({field}, {field} > 0)',
}, {
  label: 'Max',
  value: 'max',
  sql: 'max({field})',
}, {
  label: 'Min',
  value: 'min',
  sql: 'min({field})',
}];

const transforms = [{
  label: 'Value',
  value: 'value',
}, {
  label: 'URL path',
  value: 'urlPath',
  sql: 'path({field})',
}, {
  label: 'URL path segments',
  value: 'urlPathSegments',
  sql: 'URLPathHierarchy(assumeNotNull({field}))',
}, {
  label: 'Date',
  value: 'date',
  sql: 'toDate(toStartOfInterval({field}, interval 1 day, \'{timezone}\'))',
}, {
  label: 'Month',
  value: 'month',
  sql: 'toDate(toStartOfInterval({field}, interval 1 month, \'{timezone}\'))',
}, {
  label: 'Year',
  value: 'year',
  sql: 'toDate(toStartOfInterval({field}, interval 1 year, \'{timezone}\'))',
}, {
  label: 'Week',
  value: 'week',
  sql: 'toDate(toStartOfInterval({field}, interval 1 week, \'{timezone}\'))',
}, {
  label: 'First array value',
  value: 'firstValue',
  sql: 'arrayFirst(x -> 1, {field})',
}, {
  label: 'Last array value',
  value: 'lastValue',
  sql: 'arrayLast(x -> 1, {field})',
}, {
  label: 'Language',
  value: 'language',
  sql: 'substringIndex({field}, \'-\', 1)',
}, {
  label: 'Lower case',
  value: 'lowerCase',
  sql: 'lower({field})',
}, {
  label: 'Upper case',
  value: 'upperCase',
  sql: 'upper({field})',
}];

module.exports = {
  tables,
  fields,
  transforms,
  aggregations,
};
